import React from "react";

const Skills = () => {
	return (
		<div className="skills bg-dark-theme py-5 py-md-5 mt-n1">
			<div className="container-fluid">
				<div className="container px-0">
					<h2 className="text-green font-weight-bold">Skills & Expertise</h2>
					<div className="py-3">
						<h4>User Research</h4>
						<p>
							A/B Testing, Empathy Mapping, User Journey/ Mapping , Storyboarding, Surveys, Participatory Design, Usability
							Testing, User Interviews.
						</p>
					</div>
					<div className="py-3">
						<h4>User Experience</h4>
						<p>
							Experimental Design, Information Architecture, Interaction Models, Prototyping,Value-Alignment models, UX
							Strategy, Wireframing.
						</p>
					</div>
					<div className="py-3">
						<h4>Product Development</h4>
						<p>Product Management, Product Planning & Roadmapping, Requirements Gathering.</p>
					</div>
					<div className="py-3">
						<h4>Tools</h4>
						<p>Adobe Suite, Figma, Invision, UserTesting, UserZoom.</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Skills;
